<script lang="ts">
	import { Container } from '@Shelly/shelly-design-system';
	import GroupDevicesList from './GroupDevicesList.svelte';

	export let list = [];
</script>

<div class="d-flex flex-auto height-0 mb-s">
	<Container class="width-full" padding="0">
		<GroupDevicesList devices={list} />
	</Container>
</div>

<!-- <Container
	class="mb-s width-full"
	style="height: calc(100% - 160px); position: absolute;bottom: 88px;border-radius:0;"
	padding="0"
>
	<GroupDevicesList devices={list} />
</Container> -->
